export const nzProductCodes = ["CCNZGEM", "CCNZOCV", "CCNZCLN"];
